package fr.frux.shared.domain.model

/**
 * Certitude d'identification declaree a la saisie (#129).
 * TO_CONFIRM doit rester visible partout ou l'on decide de cueillir —
 * jamais gomme au rendu.
 */
enum class Certainty {
    CERTAIN,
    PROBABLE,
    TO_CONFIRM
}
